import React from 'react';
export function HeroSection() {
  return <section className="bg-cream py-10 md:py-16 px-5" data-id="element-219">
      <div className="max-w-4xl mx-auto text-center" data-id="element-220">
        {/* Eyebrow */}
        <p className="font-sans text-sm font-semibold uppercase tracking-widest text-forest mb-6" data-id="element-221">
          For Homeowners Who Actually Care About Their Garden
        </p>

        {/* Main Headline */}
        <h1 className="font-serif text-forest text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-222">
          Your Garden Is One Bad Storm Away From Total Destruction — Here's How
          To Protect Every Plant You Own, In Every Season, For Less Than a
          Coffee
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed font-sans" data-id="element-223">
          The 365 Garden Shield gives you the exact season-by-season protection
          system that saves American homeowners thousands in dead plants every
          year
        </p>

        {/* CTA Button — RED HEARTBEAT */}
        <a href="#testimonial" className="cta-heartbeat inline-block bg-red-600 hover:bg-red-700 text-white text-lg font-bold py-4 px-10 rounded-lg shadow-lg transition-colors duration-200 mb-4" data-id="element-224">
          YES! Protect My Garden Now — Only $6.37
        </a>

        {/* Trust line */}
        <p className="text-sm text-gray-500 font-sans mb-12" data-id="element-225">
          🔒 Instant Access &nbsp;|&nbsp; ✅ 7-Day Money Back Guarantee
        </p>
      </div>
    </section>;
}